<div *ngIf="alertData" class="alert alert-{{alertData.type}} d-flex">
  <div class="col-auto alert-icon">
    <mat-icon *ngIf="alertData.type == 'error'" class="material-symbols-outlined">error_outline</mat-icon>
    <mat-icon *ngIf="alertData.type == 'success'"  class="material-symbols-outlined">check_circle_outline</mat-icon>
    <mat-icon *ngIf="alertData.type == 'warning'"  class="material-symbols-outlined">info_outline</mat-icon>
  </div>
  <div class="col alert-message">
    <span>{{ alertData.message }}</span>
  </div>
</div>
